<div class="company-card">
  <div class="header">
    <h2 class="name">{{ company.name }}</h2>
    <div class="company-info">
      <p>
        CNPJ: {{ formatCnpj(company.cnpj) }} •
        {{ "admin.companyCard.code" | translate }}:
        {{ company.lmCode }}
      </p>
      <p>
        {{ "admin.companyCard.activeUsers" | translate }}:
        {{ company.activeUsersCount }}
      </p>
    </div>
  </div>

  <div class="counts">
    <span class="text-[#28b04b]"
      >{{ "admin.companyCard.totalFiles" | translate }}:
      <strong>{{ company.fileCount.totalCount }}</strong></span
    >
    <span class="text-[#0073cf]"
      >Gerber: <strong>{{ company.fileCount.gerberCount }}</strong></span
    >
    <span class="text-[#eb0a32]"
      >Lectra: <strong>{{ company.fileCount.lectraCount }}</strong></span
    >
  </div>
</div>
